module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "48",
      "src": "images/logo-synthesis.jpg",
      "width": "150"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "serpf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("A series in the history of chemistry, broadly construed, edited by Carin Berkowitz, Angela N. H. Creager, John E. Lesch, Lawrence M. Principe, Alan Rocke, and E. C. Spary, in partnership with the Science History Institute")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7883a4a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-shindell-0003.vue
// module id = 60
// module chunks = 0